/* ==========================================================================
   Karchir — ürün sayfası küçük görsel rayı

   Görseller alt alta dizili (Horizon "grid / tek sütun"). Ray:
     - tıklanınca ilgili görsele kaydırıyor
     - ekranda hangi görsel varsa o küçük görseli işaretliyor

   Not: Horizon masaüstünde sayfayı window ile değil .page-wrapper ile
   kaydırıyor; bu yüzden kendi kaydırma hesabımızı yapmıyoruz,
   scrollIntoView kullanıyoruz — o, en yakın kaydırılabilir atayı bulur.
   ========================================================================== */

(() => {
  'use strict';

  function gorseller() {
    const kap = document.querySelector('.product-information__media media-gallery .media-gallery__grid');
    if (!kap) return [];
    return [...kap.querySelectorAll('.product-media-container')];
  }

  function kur() {
    const ray = document.querySelector('[data-karchir-ray]');
    if (!ray || ray.dataset.karchirKuruldu === '1') return;
    /* Tur 146: görsel listesi SAKLANMIYOR, her seferinde gorseller() ile
       alınıyor. Beden değişince Horizon galeriyi yenisiyle değiştiriyor;
       saklanan liste sayfadan kopmuş görselleri gösteriyordu (tıklayınca
       kaymıyor, işaret yanlış kalıyordu). */
    if (!gorseller().length) return;
    ray.dataset.karchirKuruldu = '1';

    const dugmeler = [...ray.querySelectorAll('[data-karchir-ray-hedef]')];

    dugmeler.forEach((d) => {
      d.addEventListener('click', () => {
        const i = Number(d.getAttribute('data-karchir-ray-hedef'));
        const hedef = gorseller()[i];
        /* MOBİL: Horizon 750px altında dikey ızgarayı gizleyip slayt
           gösterisi basıyor. Izgara görünmüyorsa slaytı seçiyoruz. */
        const izgaraGorunur = hedef && hedef.getBoundingClientRect().height > 0;
        if (izgaraGorunur) {
          hedef.scrollIntoView({ behavior: 'smooth', block: 'start' });
          /* Tur 77 (Batuhan): "aşağı kaydırıp 3. görsele tıklayınca geri
             dönmüyor". Playwright'ta yeniden üretilemedi ama yumuşak
             kaydırma tarayıcıda başka bir kaydırmayla (tekerlek, yapışkan
             çubuk, akıllı kaydırma betiği) kesilebiliyor. Emniyet:
             800 ms sonra hedef üstte değilse anında oraya zıpla. */
          window.setTimeout(() => {
            const ust = hedef.getBoundingClientRect().top;
            /* Tur 142: kaydırma kutusundaki scroll-padding-top (yapışkan
               başlık payı) kadar aşağıda durması doğru konum */
            const pw = document.querySelector('.page-wrapper');
            const kutu = pw && window.matchMedia('(min-width: 990px)').matches ? pw : document.documentElement;
            const pay = parseFloat(getComputedStyle(kutu).scrollPaddingTop) || 0;
            if (Math.abs(ust - pay) > 6) hedef.scrollIntoView({ behavior: 'auto', block: 'start' });
          }, 800);
          return;
        }
        const slayt = document.querySelector('.product-information__media slideshow-component');
        if (slayt && typeof slayt.select === 'function') {
          try { slayt.select(i); } catch (e) {}
          isaretle(i);
        }
      });
    });

    // Mobil slayt kaydırılınca da doğru küçük görsel işaretlensin
    // (Tur 146: beden değişince gelen yeni slayta da bağlanır)
    // Tur 162 (Batuhan: "kaydırıyorum, çerçeve 1. fotoda kalıyor"): Horizon
    // olayın adı 'slideshow:select' (events.js); eski 'slideshowSlideChange'
    // hiç gelmiyordu, ray yalnız dokununca değişiyordu.
    function slaytaBagla() {
      const slaytMobil = document.querySelector('.product-information__media slideshow-component');
      if (!slaytMobil || slaytMobil.dataset.karchirRayBagli === '1') return;
      slaytMobil.dataset.karchirRayBagli = '1';
      slaytMobil.addEventListener('slideshow:select', (ev) => {
        const i = ev && ev.detail && typeof ev.detail.index === 'number' ? ev.detail.index : null;
        if (i !== null) isaretle(i);
      });
    }
    slaytaBagla();

    function isaretle(i) {
      dugmeler.forEach((d, n) => d.classList.toggle('karchir-ray__dugme--aktif', n === i));
    }

    /* Aktif küçük görsel: kaydırma sırasında, ekranın üstten %35'indeki
       çizgiye EN YAKIN görsel (Tur 81). Eski IntersectionObserver yaklaşımı
       son görseli hiç işaretlemiyordu: sayfa dibe dayanınca 4. görsel
       gözlem bandına (-20%/-40%) yeterince girmiyor, ray 3'te kalıyordu.
       Sayfa dibine gelindiyse doğrudan son görsel işaretleniyor. */
    const kaydirici = (() => {
      const w = document.querySelector('.page-wrapper');
      return w && w.scrollHeight > w.clientHeight + 4 ? w : null;
    })();
    let bekleyen = false;
    function aktifiSec() {
      bekleyen = false;
      const liste = gorseller();
      if (!liste.length) return;
      /* Tur 162: telefonda ızgara gizli (yükseklik 0), görseli slayt
         gösteriyor; işareti slideshow:select veriyor. Burada hesaplasak her
         sayfa kaydırmasında 1. görseli işaretliyordu. Slaytın o anki
         görseli işaretlenir. */
      if (!liste.some((e) => e.getBoundingClientRect().height > 0)) {
        const s = document.querySelector('.product-information__media slideshow-component');
        if (s && typeof s.current === 'number') isaretle(s.current);
        return;
      }
      const yukseklik = window.innerHeight;
      const cizgi = yukseklik * 0.35;
      const sc = kaydirici || document.scrollingElement;
      const dipte = sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 4;
      if (dipte) { isaretle(liste.length - 1); return; }
      let enIyi = 0, enKucuk = Infinity;
      liste.forEach((e, i) => {
        const r = e.getBoundingClientRect();
        if (r.height === 0) return;
        // görsel çizgiyi kapsıyorsa uzaklık 0, yoksa en yakın kenarın uzaklığı
        const uzak = r.top > cizgi ? r.top - cizgi : r.bottom < cizgi ? cizgi - r.bottom : 0;
        if (uzak < enKucuk) { enKucuk = uzak; enIyi = i; }
      });
      isaretle(enIyi);
    }
    const tetikle = () => { if (!bekleyen) { bekleyen = true; requestAnimationFrame(aktifiSec); } };
    (kaydirici || window).addEventListener('scroll', tetikle, { passive: true });
    window.addEventListener('resize', tetikle);
    aktifiSec();

    /* Tur 146: beden değişince Horizon galeriyi yeniden basıyor (eskiden
       beklenen 'variant:update' olayını bu Horizon sürümü hiç yaymıyor):
       yeni slayta bağlan, işareti ekrandaki gerçek görsele göre düzelt. */
    document.addEventListener('shopify:product:select', (olay) => {
      const soz = olay.promise;
      if (!soz || typeof soz.then !== 'function') return;
      soz
        .then(() => setTimeout(() => { slaytaBagla(); aktifiSec(); }, 350))
        .catch(() => {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }
})();

/* ==========================================================================
   Tur 144 — tükenmiş beden seçilince "Gelince haber ver" formu
   Horizon beden değişince yalnız "Sepete ekle" düğmesini yeniliyor; haber ver
   formu (snippets/karchir-haber-ver, blocks/buy-buttons.liquid) yalnız sayfa
   tükenmiş bedenle AÇILDIĞINDA basılıyordu. Müşteri tükenmiş bedene tıklayınca
   form çıkmıyordu (Batuhan, 1 Eki). Beden değişiminde Horizon'un zaten
   indirdiği sayfadan (olay sözündeki html) form ve "tükendi" işareti alınır:
   tükenmişse form gelir, stoklu bedene geçilince kalkar. Güven satırı ve aynı
   gün sayacı data-karchir-tukendi ile CSS'te gizleniyor. Hızlı ekle paneli ve
   ürün kartları hariç (panelde form zaten gizli).
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('shopify:product:select', function (olay) {
    var kaynak = olay.target;
    if (!(kaynak instanceof Element) || !olay.promise) return;
    if (kaynak.closest('product-card, dialog, .quick-add-modal')) return;
    var bolum = kaynak.closest('.shopify-section');
    var form = bolum && bolum.querySelector('product-form-component');
    if (!form) return;

    olay.promise.then(function (sonuc) {
      var html = sonuc && sonuc.detail && sonuc.detail.html;
      if (!html || typeof html.querySelector !== 'function') return;
      var yeniForm = html.querySelector('product-form-component');
      // İndirilen sayfa beklenmedikse (ör. bot doğrulama sayfası) dokunma
      if (!yeniForm) return;

      if (yeniForm.hasAttribute('data-karchir-tukendi')) form.setAttribute('data-karchir-tukendi', '');
      else form.removeAttribute('data-karchir-tukendi');

      // Tur 145: sayfa tükenmiş bedenle açıldıysa adet kutusu "disabled"
      // basılıyor; stoklu bedene geçince açık kalmıyordu ve kilitli kutu
      // forma girmediği için "+" ile 2 seçilse de 1 adet ekleniyordu.
      var yeniAdet = yeniForm.querySelector('quantity-selector-component input');
      var adet = form.querySelector('quantity-selector-component input');
      if (yeniAdet && adet && adet.disabled !== yeniAdet.disabled) adet.disabled = yeniAdet.disabled;

      // Form, ürün formu bileşeninin hemen ARDINDA (aynı blok içinde) duruyor
      var yeniKap = yeniForm.parentElement || yeniForm;
      var kap = form.parentElement || form;
      var yeni = yeniKap.querySelector('[data-karchir-haber-ver]');
      var eski = kap.querySelector('[data-karchir-haber-ver]');
      if (yeni) {
        var kopya = document.importNode(yeni, true);
        if (eski) eski.replaceWith(kopya);
        else form.insertAdjacentElement('afterend', kopya);
      } else if (eski) {
        eski.remove();
      }
    }).catch(function () { /* beden isteği iptal edildi: yeni seçim kendi olayını getirir */ });
  });
})();


/* ==========================================================================
   Tur 146 — renk değişince seçili beden taşınır
   Renkler ayrı ürün (snippets/karchir-renk-secici.liquid). Yuvarlak doğrudan
   diğer ürünün adresine gidiyordu; sayfa 2-3 yaş seçili açılıyordu. Bedeni
   seçmiş müşteri farkında olmadan yanlış bedeni ekleyebiliyordu. Bağlantıdaki
   beden → varyant eşlemesiyle aynı beden seçili açılır (o renkte tükenmişse
   "tükendi + gelince haber ver" görünür). Hızlı ekle panelinde de çalışır.
   ========================================================================== */
(function () {
  'use strict';

  function seciliBeden(kap) {
    if (!kap) return '';
    var radyo = kap.querySelector('variant-picker input[type="radio"]:checked');
    if (radyo) return radyo.value;
    var kutu = kap.querySelector('variant-picker select');
    return kutu ? kutu.value : '';
  }

  document.addEventListener('click', function (olay) {
    var bag = olay.target instanceof Element ? olay.target.closest('a.karchir-renk__nokta[data-bedenler]') : null;
    if (!bag || olay.defaultPrevented || olay.button !== 0 || olay.metaKey || olay.ctrlKey || olay.shiftKey || olay.altKey) return;
    var harita;
    try {
      harita = JSON.parse(bag.getAttribute('data-bedenler') || '{}');
    } catch (e) {
      return;
    }
    var renk = bag.closest('.karchir-renk');
    var beden = seciliBeden(renk && renk.parentElement);
    var id = beden && harita[beden];
    if (!id) return;
    olay.preventDefault();
    var adres = new URL(bag.href, location.href);
    adres.searchParams.set('variant', String(id));
    location.href = adres.toString();
  });
})();
